import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-g',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-g.component.html',
  styleUrl: './section-g.component.css'
})
export class SectionGComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection9 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionGForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'student_concern',
      questionText: 'Are those who know the student concerned the he/she may take action on violent ideas/plans? *',
      formControlName: 'student_concern',
      infoFormControlName: 'student_concern_information',
      label: 'Please explain: *'
    },
    {
      id: 'specific_target_concern',
      questionText: "Are those who know the student concerned about a specific target? *",
      formControlName: 'specific_target_concern',
      infoFormControlName: 'specific_target_concern_information',
      label: 'Please explain: *'
    },
    {
      id: 'recent_changes_behavior',
      questionText: 'Have those who know the student witnessed recent changes or escalations in mood and behavior? *',
      formControlName: 'recent_changes_behavior',
      infoFormControlName: 'recent_changes_behavior_information',
      label: 'Please explain: *'
    },
    {
      id: 'marginalize_others',
      questionText: "Does the student use terms to depersonalize or marginalize others? (Examples may include referring to others as 'it' or 'they', using derogatory statements or terms when referencing others.) *",
      formControlName: 'marginalize_others',
      infoFormControlName: 'marginalize_others_information',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['g_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.g_additional_info) || this.yesNo.No, Validators.required);    

    this.sectionGForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionGForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionGForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionG(): void {
    if (this.sectionGForm.valid) {
      this.onSaveSection9.emit(this.sectionGForm.value);
    }
  }

}
